import '@scss/common.scss';

(function(window) {
  window.expandOiv = function(e) {
    var parent = e.currentTarget.parentNode, list;
    if(parent) {
      e.currentTarget.classList.toggle('expand');
      parent.classList.toggle('expand');
      list = e.currentTarget.previousElementSibling.querySelector('.group-oivs');
      if (list) {
        list.classList.toggle('expand');
      }
    }
  };

})(window)